'use client';

import classNames from 'classnames';
import { memo } from 'react';
import { Outlet } from 'react-router';

import { LocationProvider } from '@/common/contexts/location/LocationProvider';

import { Navigation } from './navigation';

export const AppLayout = memo(() => (
  <LocationProvider>
    <div className="flex min-h-screen flex-col items-stretch lg:flex-row">
      <Navigation />

      <div
        className={classNames('flex flex-1 flex-col print:overflow-visible', {
          'max-w-clamped lg:mx-auto': false,
          'overflow-scroll': false,
          'overflow-auto': true,
        })}
      >
        <main className="relative flex w-full lg:max-h-dvh flex-1 flex-col px-6 pt-4 md:overflow-y-auto">
          <Outlet />
          <div className="w-full mt-4" />
        </main>
      </div>
    </div>
  </LocationProvider>
));
